import React from "react";
import { Input } from "reactstrap";

const PercentageInput = ({ 
  value, 
  onChange, 
  onBlur, 
  onFocus,
  name,
  placeholder = "0.0000",
  disabled = false,
  className = "",
  style = {},
  maxValue = null,
  decimals = 4,
  ...rest 
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    const raw = value?.toString().replace(/[^\d.]/g, '') || '';
    if (onFocus) {
      onFocus(e, raw);
    } else if (onChange) {
      onChange(raw);
    }
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    let numValue = parseFloat(value?.toString().replace(/[^\d.]/g, '') || '0');
    
    if (isNaN(numValue)) numValue = 0;
    
    // Negatif değerleri engelle
    if (numValue < 0) numValue = 0;
    
    // Max değeri kontrol et (varsayılan 100)
    const maxLimit = maxValue !== null ? maxValue : 100;
    if (numValue > maxLimit) numValue = maxLimit;
    
    const formatted = numValue.toFixed(decimals);
    if (onBlur) {
      onBlur(e, formatted);
    } else if (onChange) {
      onChange(formatted);
    }
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    // Sadece sayı ve nokta kabul et (negatif işareti kaldırıldı)
    const cleanedValue = inputValue.replace(/[^\d.]/g, '');
    
    const numValue = parseFloat(cleanedValue);
    
    // Negatif değerleri engelle
    if (!isNaN(numValue) && numValue < 0) {
      if (onChange) onChange('0');
      return;
    }
    
    // Max değeri kontrol et (varsayılan 100)
    const maxLimit = maxValue !== null ? maxValue : 100;
    if (!isNaN(numValue) && numValue > maxLimit) {
      if (onChange) onChange(maxLimit.toString());
      return;
    }
    
    if (onChange) {
      onChange(cleanedValue);
    }
  };

  // Format display value
  const formatDisplay = (val) => {
    if (!val || val === '') return '';
    const cleanVal = val.toString().replace(/[^\d.]/g, '');
    if (!cleanVal) return '';
    return `${cleanVal}%`;
  };

  const displayValue = isFocused 
    ? value?.toString().replace(/[^\d.]/g, '') || '' 
    : formatDisplay(value);

  return (
    <Input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      style={{ textAlign: 'right', ...style }}
      {...rest}
    />
  );
};

export default PercentageInput;

